import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  columns: number;
  message?: string;
}

const EmptyTable = ({ columns, message }: IProps) => {
  const { t } = useTranslation();
  const midIndex = Math.floor(columns / 2);
  return (
    <tr>
      {Array.from({ length: columns }, (_, i) => (
        <td key={i}>
          {i === midIndex ? (
            <p className={'text-center mb-0'}>{t('general.emptyList')}</p>
          ) : (
            ''
          )}
        </td>
      ))}
    </tr>
  );
};

export default EmptyTable;
